<div
  tabindex="0"
  class="size-wrapper"
  [ngClass]="{ selected: isSelected, disabled: disabled }"
  (click)="onSizeSelect()"
  (keydown)="onSizeSelect($event)"
>
  {{ name.toString() | uppercase }}
</div>
